/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import React from 'react';
import { useStyles } from './LftTaskCard.styles';

export type LftTaskCardProps = {
    id: string;
    primaryContent: string;
    icon?: React.ReactNode;
    onClick: () => void;
};

export const LftTaskCard: React.FC<LftTaskCardProps> = ({
    primaryContent,
    icon,
    onClick
}) => {
    const styles = useStyles();

    return (
        <div className={styles.taskCard} onClick={onClick}>
            {icon && <div className={styles.taskCircle}>{icon}</div>}
            <div className={styles.taskText}>{primaryContent}</div>
        </div>
    );
};
